import React, { Fragment, useState, useEffect, useContext } from "react";
import clienteAxios from "../../config/axios";
import { notification, Row, Breadcrumb, Button, Col } from "antd";
import Card_Producto from "../../pages/users/Productos/Cards_Normales/card_producto";
import Spin from "../Spin";
import "./busqueda_categorias.scss";
import { MenuContext } from "../../context/carritoContext";
import { makeStyles } from "@material-ui/styles";
import { Container } from "@material-ui/core";

function BusquedaCategorias(props) {
  const categoria = props.match.params.categoria;
  const subcategoria = props.match.params.subcategoria;
  const temporada = props.match.params.temporada;
  const genero = props.match.params.genero;

  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState([]);
  const { reloadFilter, setReloadFilter, colores } = useContext(MenuContext);
  const [todosProductos, setTodosProductos] = useState(false);
  const token = localStorage.getItem('token');

  const obtenerFiltrosDivididos = async (
    categoria,
    subcategoria,
    temporada,
    genero
  ) => {
    let cat = categoria;
    let sub = subcategoria;
    let temp = temporada;
    let gen = genero;

    if (categoria === "null") {
      cat = "";
    }
    if (subcategoria === "null") {
      sub = "";
    }
    if (genero === "null" || genero === "Todos") {
      gen = "";
    }
    if (temporada === "null") {
      temp = "";
    }

    setLoading(true);
    await clienteAxios
      .get(
        `/productos/filter?categoria=${cat}&subcategoria=${sub}&genero=${gen}&temporada=${temp}`
      )
      .then((res) => {
        setResultado(res.data.posts);
        setLoading(false);
        setTodosProductos(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          notification.error({
            message: "Error",
            description: err.response.data.message,
            duration: 2,
          });
        } else {
          notification.error({
            message: "Error de conexion",
            description: "Al parecer no se a podido conectar al servidor.",
            duration: 2,
          });
        }
      });
  };

  const obtenerTodos = async () => {
    await clienteAxios
      .get(`/productos/sinPaginacion`)
      .then((res) => {
        setResultado(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          notification.error({
            message: "Error",
            description: err.response.data.message,
            duration: 2,
          });
        } else {
          notification.error({
            message: "Error de conexion",
            description: "Al parecer no se a podido conectar al servidor.",
            duration: 2,
          });
        }
      });
  };

  const limpiarFiltros = () => {
    setReloadFilter(!reloadFilter);
    obtenerTodos();
    setTodosProductos(true);
  };

  useEffect(() => {
    return () => {
      limpiarFiltros();
    };
  }, []);

  useEffect(() => {
    obtenerFiltrosDivididos(categoria, subcategoria, temporada, genero);
  }, [props.location]);

  const useStyles = makeStyles({
    text: {
      color: colores.bodyPage.text,
      "& .bread-font": {
        color: colores.bodyPage.text,
      },
      "& .ant-breadcrumb-separator": {
        color: colores.bodyPage.text,
      },
    },
  });
  const classes = useStyles();

  const render = resultado.map((productos, index) => {
    if (productos.socios && token === null) {
      return null;
    } else {
      return (
        <Col key={index} xs={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
          <Card_Producto productos={productos} />
        </Col>
      );
    }
  });

  return (
    <Fragment>
      <Spin spinning={loading}>
        <div className={"my-4 mx-3 " + classes.text}>
          <h3 className={"d-inline mr-3 font-prin " + classes.text}>
            {resultado.length} resultados en el menu:{" "}
          </h3>
          {todosProductos ? (
            <h3 className={"d-inline font-prin " + classes.text}>
              Todos los productos
            </h3>
          ) : (
            <Breadcrumb
              separator=">"
              className={"d-inline font-prin " + classes.text}
            >
              <Breadcrumb.Item className="bread-font">
                {categoria !== "null" ? categoria : null}
              </Breadcrumb.Item>
              <Breadcrumb.Item className="bread-font">
                {subcategoria !== "null" ? subcategoria : null}
              </Breadcrumb.Item>
              <Breadcrumb.Item className="bread-font">
                {temporada !== "null" ? temporada : null}
              </Breadcrumb.Item>
              <Breadcrumb.Item className="bread-font">
                {genero !== "null" ? genero : null}
              </Breadcrumb.Item>
            </Breadcrumb>
          )}
          <div>
            <Button
              type="primary"
              size="large"
              className="mt-3 color-boton"
              onClick={limpiarFiltros}
            >
              Limpiar filtros
            </Button>
          </div>
        </div>
        <Container>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>{render}</Row>
        </Container>
      </Spin>
    </Fragment>
  );
}

export default BusquedaCategorias;
